import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';

import { TranslocoDirective } from '@jsverse/transloco';
import { DealerGroupSelectionSectionComponent } from '../dealer-group-selection-section/dealer-group-selection-section.component';
import {
  selectAllMembersSelected,
  selectDealerGroupCount
} from 'src/inventory-management/services/lead-seller-group/reducer';
import {
  LeadSellerPreferencesService
} from '../../services/lead-seller-preferences/lead-seller-preferences.service';
import { LeadSellerGroupService } from '../../services/lead-seller-group/lead-seller-group.service';
import { TrackDirective } from 'remarketing-ui-components-lib';

@Component({
  selector: 'app-preferences-popover-2',
  templateUrl: './preferences-popover.component.html',
  styleUrl: './preferences-popover.component.scss',
  imports: [AsyncPipe, TranslocoDirective, DealerGroupSelectionSectionComponent, TrackDirective],
  standalone: true
})
export class PreferencesPopoverComponent implements OnInit {
  preferencesState$ = this.leadSellerPreferencesService.state$;

  dealerGroups$ = this.leadSellerPreferencesService.state$;
  readonly allSelected$: Observable<boolean> = this.leadSellerPreferencesService.select(selectAllMembersSelected);
  dealershipGroupCount = 0;

  constructor(
    private leadSellerPreferencesService: LeadSellerPreferencesService,
    private leadSellerGroupService: LeadSellerGroupService
  ) {}

  ngOnInit() {
    this.leadSellerGroupService.search('');
    this.leadSellerGroupService.select(selectDealerGroupCount).subscribe(groupCount => {
      this.dealershipGroupCount = groupCount;
    });
  }

  toggleAll() {
    this.leadSellerPreferencesService.toggleAll();
  }

  search(e) {
    this.leadSellerGroupService.search(e.target.value.toLowerCase().trim());
  }

  toggleGroup(groupUuid: string) {
    this.leadSellerPreferencesService.toggleGroup(groupUuid);
  }

  toggleMember(uuid: string) {
    this.leadSellerPreferencesService.toggleMember(uuid);
  }

  get isSellerAssociatedToMultipleLeadSellerGroup() {
    return this.dealershipGroupCount && this.dealershipGroupCount > 1;
  }
}
